import React, { useState } from 'react';
import * as S from './CollapsableContainer.styles';

interface ICollapsable {
    containerHeight?: string,
    defaultState?: boolean,
    collapsedText?: string,
    expandedText?: string,
    shadowColor?: string
}

const CollapsableContainer: React.FC<ICollapsable> = ({ containerHeight = '12rem', children, defaultState = true, collapsedText = "Read More", expandedText = "Read Less", shadowColor = "#fff" }) => {
    const [collapsed, setCollapsedState] = useState(defaultState);
    return (
        <React.Fragment>
            <S.CollapsableContainer cHeight={collapsed ? containerHeight : 'unset'}>
                {children}
            </S.CollapsableContainer>
            <S.CollapsableContainerText shadowColor={shadowColor} onClick={() => setCollapsedState(!collapsed)}>{collapsed ? collapsedText : expandedText}</S.CollapsableContainerText>
        </React.Fragment>
    )
}

export default CollapsableContainer;
